"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_COOKIE_CONSENT_PREFERENCES = void 0;
exports.DEFAULT_COOKIE_CONSENT_PREFERENCES = {
    necessary: true,
    functionality: true,
    analytics: true,
    advertising: true,
};
//# sourceMappingURL=cookieConsentPreferences.js.map